var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper planAdd-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_vm._v("Assign Plan To Group "), _vm.groupName ? _c('span', [_vm._v(" (" + _vm._s(_vm.groupName) + ")")]) : _vm._e()])]), _c('div', [_c('employer-group-plan-select-card-list', {
    attrs: {
      "groupId": _vm.groupId
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }